import { useEffect, useState } from "react";
import { Group, Layer, Line, Rect, Stage, Text } from "react-konva";
import { getDeviceConfig, getElectricityInfo } from "../../../api/api";
import LoadImage from "../../../commons/LoadImage";
import Spinner from "../../../commons/Spinner";
import { cursorGrab, handleStageDragStart, handleStageWheel, renderonlyPcs, renderPcs, handleStageDragMoveSayama } from "../../../utils/DiagramParts";
import { formatPower } from "../../../utils/NumberUtils";


const SayamaElec = ({ setSelected, setDeviceArr, goToInfo, deviceId }) => {

    const transfomer = ['TR1Φ\n\n3W\n\n210V-105V', 'TR 3Φ\n\n125kVA\n\n420V/210V', 'TR3Φ\n\n125kVA\n\n420V/210V'];
    const stageScale = 1;

    const [scene, setScene] = useState({ width: window.innerWidth, height: window.innerHeight - 150 });
    const [isLoading, setIsLoading] = useState(true);
    const authToken = localStorage.getItem('accessToken');
    const [deviceList, setDeviceList] = useState({
        batArr: [
            {
                device_id: 'BTPCS1',
                // device_id: 'BTPCS1'
            },
            {
                device_id: 'BTPCS2',
                // device_id: 'BTPCS2'
            },
        ],
        pcsArr: [
            {
                device_id: '111KWPCS1',
                device_maker_type: "HUAWEI"
            },
            {
                device_id: '111KWPCS2',
                device_maker_type: "HUAWEI"
            },
            {
                device_id: 'PVPCS1',
                device_maker_type: "HUAWEI"
            },
            {
                device_id: 'PVPCS2',
                device_maker_type: "HUAWEI"
            },
        ],
        multiMeter: [{
            device_id: 'MMR',
            device_maker_type: 'MITSUBISHI'
        }],
        sum_generating: 0,
        rs_line_volt: 0,
        st_line_volt: 0,
        tr_line_volt: 0,
        real_power: 0
    });

    useEffect(() => {
        if (deviceId !== null) {
            const controller = new AbortController();
            const signal = controller.signal;
            const fetchDevices = async (signal) => {
                setIsLoading(true);
                // Promise.all([
                let deviceDataDefault = deviceList;
                let multimeterDefault = {
                    sum_generating: 0,
                    rs_line_volt: 0,
                    st_line_volt: 0,
                    tr_line_volt: 0,
                    real_power: 0
                };
                let multimeterData = null;

                const deviceDataFetched = await getDeviceConfig(authToken, deviceId, { configType: 'network_config' }, signal);

                if (deviceDataFetched.length > 0) {
                    const hybridPcs = deviceDataFetched.filter(el => el.device_id.toLowerCase().includes('50'));
                    const multiMeter = deviceDataFetched.filter(el => el.device_maker_type.toLowerCase().includes('mitsubishi'));
                    const batArr = deviceDataFetched.filter(el => el.device_id.toLowerCase().startsWith('btpcs')
                    ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));

                    const pcsArr = deviceDataFetched.filter(el => el.device_name.toLowerCase().startsWith('pv_pcs')
                    ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));
                    setScene({ width: window.innerWidth, height: window.innerHeight + batArr.length * 270 });
                    // setDeviceList({ ...deviceList, hybridPcs, multiMeter, batArr, pcsArr });
                    deviceDataDefault = { hybridPcs, multiMeter, batArr, pcsArr };
                    multimeterData = multiMeter;
                    setDeviceArr([...hybridPcs, ...multiMeter, ...batArr, ...pcsArr]);
                }

                if (multimeterData !== null) {
                    const multiMeterFetched = await getElectricityInfo(authToken, deviceId, { ...multimeterData[0] }, signal);
                    if (multiMeterFetched !== null) {
                        multimeterDefault = multiMeterFetched;
                    }
                }

                setDeviceList({ ...deviceDataDefault, ...multimeterDefault });
                setIsLoading(false);
            };
            fetchDevices(signal);
            return () => {
                controller.abort();
            };
        }//eslint-disable-next-line
    }, [deviceId]);

    const cursorPoint = (e) => {
        const container = e.target.getStage().container();
        container.style.cursor = 'pointer';
    };

    const cursorNormal = (e) => {
        const container = e.target.getStage().container();
        container.style.cursor = 'default';
    };

    const getCurrentBoxLine = (n) => {
        const x = 80;
        let y = 110;

        if (n === 0) {
            return <Line stroke="black" points={[0, 80, 0, 80, 115, 80, 115, 100]} />
        }
        if (n === 1) {
            return <Line stroke="black" points={[0, 170, 0, 80, 170, 80, 170, 100]} />
        } else {
            const val = [<Line stroke="black" points={[0, 170, 0, 80, 80, 80, 80, 100, 80, 110, 100, 110]} />];

            for (let i = 0; i < n - 1; i++) {
                val.push(<Line stroke="black" points={[x, y, x, y + 270, x, y + 400, x + 20, y + 400, x + 20, y + 400]} />);
                y += 270;
            }
            return val;
        }
    };

    if (deviceList === null) {
        return null;
    }

    return (
        <>{isLoading ? <Spinner /> :
            <Stage
                id='sayama'
                width={scene.width}
                height={scene.height}
                scaleX={+stageScale}
                scaleY={+stageScale}
                onWheel={handleStageWheel}
                draggable={true}
                onDragStart={handleStageDragStart}
                onDragEnd={cursorGrab}
                onMouseOver={cursorGrab}
                onDragMove={handleStageDragMoveSayama}
            >
                <Layer>
                    {renderPcs([deviceList.batArr[0], deviceList.pcsArr[2], deviceList.batArr[1], deviceList.pcsArr[3]], 160, 280, setSelected, goToInfo, deviceList.pcsArr.length)}
                    {renderonlyPcs([deviceList.pcsArr[0]], 885, 265, setSelected, goToInfo, deviceList.pcsArr.length, "sayama")}
                    {renderonlyPcs([deviceList.pcsArr[1]], 1135, 265, setSelected, goToInfo, deviceList.pcsArr.length, "sayama")}

                    {/* Top button */}
                    <Group x={0} y={0}>
                        <Rect width={120} height={30} stroke="#000000" fill="#99ffcc" strokeWidth={1} />
                        <Text text="地絡過電圧OVGR" padding={10} fontVariant="bold" fontSize={13} />
                    </Group>
                    {/* Main line */}
                    <Group x={240} y={0}>
                        {/* Button */}
                        <Rect width={45} height={30} stroke="#000000" fill="#fff" strokeWidth={1} cornerRadius={4} />
                        <Text
                            text="系統"
                            padding={9}
                            fontVariant="bold"
                            fontSize={13}
                        />
                        <Line stroke="black" points={[45 / 2, 30, 45 / 2, 100]} />
                        <Text
                            text={deviceList.multiMeter[0]?.device_id.toString()}
                            fontVariant="bold"
                            fontSize={13}
                            x={-35}
                            y={120}
                            fill="blue"
                            textDecoration="underline"
                            onClick={(e) => setSelected(deviceList.multiMeter[0])}
                            onMouseEnter={cursorPoint}
                            onMouseLeave={cursorNormal}
                        />
                        <Rect x={0} y={100} width={40} height={55} strokeWidth={1} stroke="black" fill="red" />
                        <LoadImage src="/img/vcb.png" x={3} y={100} height={100 / 1.80} width={46 / 1.80} />
                        <Line stroke="black" points={[45 / 2, 155, 45 / 2, 180]} />
                    </Group>

                    {/* Table */}
                    <Group x={350} y={10}>
                        {/* Title */}
                        <Text text="系統電圧・電力" fontVariant="bold" padding={9} offsetX={5} />

                        <Rect width={150} height={80} stroke="#000000" fill="#fff" strokeWidth={1} x={0} y={25} />
                        {/* Inner Lines */}
                        {Array(3)
                            .fill()
                            .map((el, i) => (
                                <Line
                                    x={0}
                                    y={25}
                                    points={[0, (i + 1) * 20, 150, (i + 1) * 20]}
                                    stroke="#00000"
                                    strokeWidth={1}
                                    key={i}
                                />
                            ))}
                        {/* Data */}
                        {[deviceList.rs_line_volt, deviceList.st_line_volt, deviceList.tr_line_volt, deviceList.real_power].map((el, i) => (
                            <Text x={20} y={25 + i * 20} text={(i <= 2) ?
                                !el ? "---V" : !el ? "---W" : Number(el).toFixed(2) + 'V' :
                                (formatPower(el, 2))} padding={4} key={i} />
                        ))}
                    </Group>

                    <Group x={0} y={180}>

                        {/* Left Side */}
                        <Group x={60} y={0}>
                            <LoadImage src="/img/left.svg" height={80} width={80} x={1} y={0} />
                            {/* Left Text */}
                            <Text text={transfomer[0]} x={70} y={20} lineHeight={0.675} />
                            {/* m */}
                            {getCurrentBoxLine(1)}
                            <Rect width={45} height={30} x={-20} y={170} stroke="#000000" strokeWidth={1} fill="#fff" />
                            <Text
                                text="負荷"
                                x={-20}
                                y={170}
                                padding={10}
                                fontVariant="bold"
                                onClick={(e) => console.log('left')}
                                onMouseEnter={cursorPoint}
                                onMouseLeave={cursorNormal}
                            />
                        </Group>

                        {/* Bridge */}
                        {/* Bridge Line */}
                        {/* SumGenerating */}
                        <Line stroke="black" points={[100, 0, 1400, 0]} />

                        {/* AC Collector Box */}
                        {/* <Group x={850} y={100}>
                            <Rect width={400} height={30} stroke="black" strokeWidth={1} fill="#fff" />
                            <Text text={'交流集電箱'} fontVariant="bold" fontSize={13} padding={10} x={150} />
                        </Group> */}

                        {/* Right */}
                        <Group x={1050} y={0}>
                            <LoadImage src="/img/right.svg" height={85} width={80} x={10} y={0} />
                            <Text text={transfomer[2]} x={80} y={20} lineHeight={0.675} />
                            {/* {getCurrentBoxLine(1)} */}
                            <Line points={[0, 170, 0, 85, 100, 85, 100, 100]} stroke="black" />
                            <Group x={-20} y={170}>
                                <Rect width={45} height={30} stroke="#000000" strokeWidth={1} fill="#fff" />
                                <Text
                                    text="負荷"
                                    padding={10}
                                    fontVariant="bold"
                                />
                            </Group>
                        </Group>

                        {/* Middle */}
                        <Group x={800} y={0}>
                            <LoadImage src="/img/right.svg" height={85} width={80} x={1} y={0} />
                            <Text text={transfomer[1]} x={70} y={20} lineHeight={0.675} />
                            {/* {getCurrentBoxLine(1)} */}
                            <Line points={[0, 170, 0, 85, 100, 85, 100, 100]} stroke="black" />
                            <Rect width={45} height={30} x={-20} y={170} stroke="#000000" strokeWidth={1} fill="#fff" />
                            <Text
                                text="負荷"
                                x={-20}
                                y={170}
                                padding={10}
                                fontVariant="bold"
                                onClick={(e) => console.log('left')}
                                onMouseEnter={cursorPoint}
                                onMouseLeave={cursorNormal}
                            />
                        </Group>


                        <Group x={1350} y={0}>
                            <LoadImage src="/img/left.svg" height={80} width={80} x={10} y={0} />
                            <Text text={transfomer[0]} x={80} y={20} lineHeight={0.675} />
                            {/* {getCurrentBoxLine(0)} */}
                            {/* <Line points={[0, 170, 0, 80, 100, 80, 100, 100]} stroke="black" /> */}
                            <Group x={30} y={80}>
                                <Rect width={45} height={30} stroke="#000000" strokeWidth={1} fill="#fff" />
                                <Text
                                    text="負荷"
                                    padding={10}
                                    fontVariant="bold"
                                />
                            </Group>
                        </Group>
                    </Group>

                </Layer>

            </Stage>
        }</>
    )

}

export default SayamaElec;